import {useMemo} from "react";

import {useNotificationFeedStore} from "@/src/modules/notification-feed/store";

/** Unread DM bell rows from the v2 notification feed store (same source as communications bell). */
export function useDirectMessageFeedUnreadCount() {
  const items = useNotificationFeedStore((state) => state.items);

  return useMemo(
    () =>
      items.filter(
        (item) => item.topic === "direct_message" && !item.read_at && !item.discarded_at,
      ).length,
    [items],
  );
}
